import React from 'react';
import { Route, IndexRoute, Redirect } from 'react-router';
import ConfigurableProductContainer from 'split-chunk-loader?lazy!../ConfigurableProduct/ConfigurableProductContainer';
import PartnerCategoryProductsContainer from 'split-chunk-loader?lazy!../PartnerCategoryProducts/PartnerCategoryProductsContainer';
import { lazify } from '../Common/Helper';


const ConfigurableProductRoutes = (
  <Route>
    <Redirect from="configurable-product/kids-art-keepsakes" to="/404.html" />
    <Route path="configurable-product/:slug">
      <IndexRoute component={lazify(ConfigurableProductContainer)} />
    </Route>
    <Route path="personalise/:partnerCode/:categoryCode">
      <IndexRoute component={lazify(PartnerCategoryProductsContainer)} />
    </Route>
  </Route>
);

export default ConfigurableProductRoutes;



// WEBPACK FOOTER //
// ./src/Routes/ConfigurableProductRoutes.js